// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🔹 Contenedor principal de las imágenes colaborativas */
.collab-images-container {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 100;
  color: black;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
}

/* 🔹 Botón individual de imagen */
.collab-image-button {
  all: unset;
  height: 50px;
  width: 50px;
  border-radius: 8px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  transition: transform 0.2s ease;
}

/* 🔹 Imagen dentro del botón */
.collab-image-button img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 🔹 Botón pequeño con el icono de más (los tres puntos) */
.collab-image-more {
  all: unset;
  height: 32px;
  width: 32px;
  border-radius: 6px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  background-color: #141414;
  color: white;
  transition: background-color 0.2s ease;
}

.collab-image-more:hover {
  background-color: #222;
}

/* 🔹 Responsive: cuando la altura de la ventana es pequeña */
@media (max-height: 500px) {
  .collab-images-container {
    top: 44px; /* 📏 Más separación para no superponerse con la barra superior */
  }
}
`, "",{"version":3,"sources":["webpack://./react/features/whiteboard/custom-ui/styles/custom-ui.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6DAA6D;AAC7D;EACE;IACE,SAAS,EAAE,iEAAiE;EAC9E;AACF","sourcesContent":["/* 🔹 Contenedor principal de las imágenes colaborativas */\n.collab-images-container {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  z-index: 100;\n  color: black;\n\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n/* 🔹 Botón individual de imagen */\n.collab-image-button {\n  all: unset;\n  height: 50px;\n  width: 50px;\n  border-radius: 8px;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  overflow: hidden;\n  transition: transform 0.2s ease;\n}\n\n/* 🔹 Imagen dentro del botón */\n.collab-image-button img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* 🔹 Botón pequeño con el icono de más (los tres puntos) */\n.collab-image-more {\n  all: unset;\n  height: 32px;\n  width: 32px;\n  border-radius: 6px;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  overflow: hidden;\n  background-color: #141414;\n  color: white;\n  transition: background-color 0.2s ease;\n}\n\n.collab-image-more:hover {\n  background-color: #222;\n}\n\n/* 🔹 Responsive: cuando la altura de la ventana es pequeña */\n@media (max-height: 500px) {\n  .collab-images-container {\n    top: 44px; /* 📏 Más separación para no superponerse con la barra superior */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
